import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=f1753e40"
import script from "./FaqSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports